module.exports = __webpack_public_path__ + "media/images/start-d2477c6ce5aa6c34f580f28a458cec08.png";